module.exports = __webpack_public_path__ + "img/icon_vip_youku@2x.1eb77f8f.png";